setTimeout(function () {
  let inventoriesPartials = document.querySelector('a.inventoriesPartials');
  inventoriesPartials && inventoriesPartials.click();
}, 200);